import AppRouter from './AppRouter'
import Theme from './assets/styles/theme'
import Header from './components/layout/header'
import Footer from './components/Footer'
import styled from 'styled-components'
import ReactGA from 'react-ga4'
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { usePageMeta } from './hooks/pageMeta'
import {
  preloadCriticalImages,
  lazyLoadBackgroundImages,
} from './utils/imageOptimization'
// TODO Move this into environment vairable
const TRACKING_ID = 'G-PDJ3D4Y0C0'

function App() {
  const location = useLocation()
  usePageMeta()

  useEffect(() => {
    ReactGA.initialize(TRACKING_ID)

    // Preload critical images for better performance
    preloadCriticalImages([
      '/images/logos/optimized/full-logo-230x80.webp',
      '/images/homepage/HeroSection_Desktop.webp',
      '/images/homepage/HeroSection_Mobile.webp',
    ])

    // Initialize lazy loading for background images
    lazyLoadBackgroundImages()
  }, [])

  useEffect(() => {
    ReactGA.send({
      hitType: 'pageview',
      page: location.pathname + location.search,
      title: document.title || 'Community of Guardians',
    })
  }, [location])

  return (
    <Theme>
      <AppContainer>
        <Header />
        <MainContent>
          <AppRouter />
        </MainContent>
        <Footer />
      </AppContainer>
    </Theme>
  )
}

const MainContent = styled.main`
  flex: 1;
  display: flex;
  flex-direction: column;
`

const AppContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
`

export default App
